import type {KeenSliderOptions} from "keen-slider";

export const SLIDER_CONFIG = {
    mobile: {perView: 1, spacing: 16},
    tablet: {perView: 2.2, spacing: 42, origin: "center" as const},
    desktop: {perView: 2.8, spacing: 42, origin: "center" as const},
} as const;

export function createSliderConfig(videosCount: number): KeenSliderOptions | undefined {
    if (!videosCount || videosCount === 0) {
        return undefined;
    }

    return {
        slides: SLIDER_CONFIG.mobile,
        breakpoints: {
            "(min-width: 768px)": {
                slides: SLIDER_CONFIG.tablet,
            },
            "(min-width: 1500px)": {
                slides: SLIDER_CONFIG.desktop,
            },
        },
        drag: true,
        loop: videosCount > 1,
        mode: "snap",
        initial: 0,
    };
}
